<template>
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2248:22802)">
      <path
        d="M26.1456 0.985352C24.6778 3.79094 29.4642 9.52411 25.8265 13.1226C20.3381 18.5508 16.8133 25.5879 16.1751 32.9678H27.3633C27.3633 32.9678 27.3582 38.4537 20.2105 42.9061C20.2105 42.9061 34.0591 43.9429 34.1867 27.4143C30.1662 27.3533 24.1672 27.4143 24.1672 27.4143C24.6778 25.5236 25.8265 22.6372 28.8898 19.7096C30.1024 18.5508 33.6124 16.7211 36.8671 20.4415C41.2706 25.5648 41.3344 31.8469 41.3344 32.5178C41.3344 41.6054 33.6124 48.9854 24.1034 48.9854C15.1688 48.9244 7 43.0082 7 32.5178C7 13.4275 26.1456 0.985352 26.1456 0.985352Z"
        :fill="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_2248:22802">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.985352)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsEnergy'
})

defineProps({
  fill: {
    type: String,
    default: '#0AC16A'
  }
})
</script>
